import {TableColumn} from '@fl/cmsch-fe-library';

import {getFarmCodeFormat} from './farm-code-format';
import {BreederRoleTableType} from '../../types/breeder-role-table-type';

/** Table columns for the breeders tab. */
export const columns: Array<TableColumn<BreederRoleTableType>> = [
    {
        field: 'breederRegistrationNumber',
        type: 'number',
        formatValue: String,
        align: 'left',
    },
    {
        field: 'subjectName',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'roleCode',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'roleName',
        type: 'string',
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
    {
        field: 'approvedFrom',
        type: 'date',
        dateFormat: 'date',
    },
    {
        field: 'approvedTo',
        type: 'date',
        dateFormat: 'date',
        filterTypes: ['null'],
    },
    {
        field: 'farmCode',
        type: 'string',
        formatValue: getFarmCodeFormat,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    },
];
